import React from 'react';
import { RadioButtonConfirmWrapper } from './styledConstants';
import { isEmpty } from '../../utils/common';



const RadioButtonConfirm = ({className="", label="", heading="",name="", checked=false,error="",onClick=()=>{} ,onChange=()=>{},value="", img=""}) => {
  return (
    <RadioButtonConfirmWrapper className={className}>
   <label className={`container ${checked?"active":""}`} id={"radio"+value} onClick={()=>onClick(value)}>
    <div className='flex gap-10'>
  
     <div>
      
        {heading && <h2>{heading}</h2>}
        {label && <p>{label}</p>}
       
     
     </div>
      <input
        type="radio"
        name={name}
        checked={checked}
        onClick={onChange}
        value={value}
        for={"radio"+value}
        
      />
     
      {!isEmpty(img) &&  <img src={img} alt="" />}
      {isEmpty(img) &&  <span className="checkmark"></span>}
        
      
    </div>
    </label>
    {(error !=="")&&<div className="error">
       {error}
    </div>}
    </RadioButtonConfirmWrapper>
    
  );
};

export default RadioButtonConfirm;